import { axiosInstance } from './axiosInstance';
import { getAxiosInstanceMethods } from 'utils/Axios';

export const tokenizationApi = getAxiosInstanceMethods(axiosInstance);
